import { ValueOf } from './enums/notificationType.enum';

// =====================================================================
// Preferenze notifiche + consensi GDPR.
// Owner scritture: backend (il notification-service legge soltanto).
// Stato corrente in `user_notification_preference`, storia append-only
// in `user_consent` (scritte nella stessa transazione).
// =====================================================================

export const ConsentType = Object.freeze({
	MARKETING_PUSH: 'marketing_push',
	MARKETING_EMAIL: 'marketing_email',
});
export type ConsentTypeValues = ValueOf<typeof ConsentType>;

export const ConsentSource = Object.freeze({
	REGISTRATION: 'registration',
	MOBILE_APP: 'mobile_app',
	UNSUBSCRIBE_LINK: 'unsubscribe_link',
	ADMIN: 'admin',
});
export type ConsentSourceValues = ValueOf<typeof ConsentSource>;

// Stato corrente — una riga per utente, PK userId.
// service*/personal* default true (legittimo interesse), marketing* default
// FALSE (GDPR opt-in). Le notifiche TRANSACTIONAL (pagamenti/addebiti) NON
// hanno preferenza: sempre consegnate per vincolo legale.
export interface IUserNotificationPreference {
	userId: string;
	servicePushEnabled: boolean;
	serviceEmailEnabled: boolean;
	marketingPushEnabled: boolean;
	marketingEmailEnabled: boolean;
	/** Attività personale non economica: inizio/stato/fine ricarica, prenotazioni. */
	personalPushEnabled: boolean;
	personalEmailEnabled: boolean;
	updatedAt?: Date;
}

// Audit trail append-only: ogni variazione di consenso marketing è una riga.
export interface IUserConsent {
	id?: number;
	userId: string;
	consentType: ConsentTypeValues;
	granted: boolean;
	source: ConsentSourceValues;
	occurredAt?: Date;
}

export interface IUpdateNotificationPreferencesDTO {
	servicePushEnabled?: boolean;
	serviceEmailEnabled?: boolean;
	marketingPushEnabled?: boolean;
	marketingEmailEnabled?: boolean;
	personalPushEnabled?: boolean;
	personalEmailEnabled?: boolean;
	/** Da dove arriva la modifica — finisce nell'audit trail. */
	source: ConsentSourceValues;
}
